import { useMutation, useQueryClient } from "react-query";

import { PositionPutSchema } from "~/entity/Positions/model/schema";

import { POSITIONS_QUERY_KEY } from "./useGetPositions";
import { usePositions } from "./usePositions";

interface MutateOptions {
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  instanceId: number | string;
  data: PositionPutSchema;
  options?: MutateOptions;
}

export const useUpdatePosition = (
  queryKey: string | any[] = POSITIONS_QUERY_KEY
) => {
  const { positionPut } = usePositions();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const result = await positionPut(props.instanceId, props.data);
      if (result.data) {
        return result.data;
      } else {
        throw new Error("Не удалось обновить должность");
      }
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
    onSettled: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });

  const update = (
    instanceId: number | string,
    data: PositionPutSchema,
    options?: MutateOptions
  ) => {
    mutation.mutate({ instanceId, data, options });
  };

  return { update, isLoading: mutation.isLoading };
};
